// Import model
import { CreatePointRequest } from '../models/CreatePointRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreatePointRequest - handles JSON serialization and deserialization with type validation
 */
export class CreatePointRequestSerializer {
  /**
   * Deserializes a JSON string into a CreatePointRequest instance
   */
  static deserialize(json: string): CreatePointRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreatePointRequest instance
   */
  static fromObject(obj: any): CreatePointRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreatePointRequest');
    }


    const instance: CreatePointRequest = {
      x: obj['x'] as number,
      y: obj['y'] as number,
      z: obj['z'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreatePointRequest instances
   */
  static deserializeArray(json: string): CreatePointRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreatePointRequest instance to a JSON string
   */
  static serialize(instance: CreatePointRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreatePointRequest instance to a plain object
   */
  static toObject(instance: CreatePointRequest): any {
    return {
      'x': instance.x,
      'y': instance.y,
      'z': instance.z,
    };
  }

  /**
   * Serializes an array of CreatePointRequest instances to a JSON string
   */
  static serializeArray(instances: CreatePointRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
